import { BaseOption } from 'ui/selects';
import { PHONE_COUNTRY, PHONE_TYPE } from 'utils/fieldConstants';

import {
  useConditionState,
  useGetCountryDisplayName,
  useGetPhoneTypeDisplayName,
} from '../../../hooks';
import { FieldFacet } from '../../../types';

export const useGetFieldFacetOption = () => {
  const [{ field }] = useConditionState();
  const getCountryDisplayName = useGetCountryDisplayName();
  const getPhoneTypeDisplayName = useGetPhoneTypeDisplayName();

  return function getFieldFacetOption({ term }: FieldFacet): BaseOption<string> {
    if (field === PHONE_COUNTRY) {
      return {
        value: term,
        id: term,
        label: getCountryDisplayName(term),
        doubleLine: term,
      };
    }

    if (field === PHONE_TYPE) {
      return {
        value: term,
        id: term,
        label: getPhoneTypeDisplayName(term),
        doubleLine: term,
      };
    }

    return {
      value: term,
      id: term,
      label: term,
    };
  };
};
